var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorToastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEE4E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FEF3F2",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8307 18.8333L22.9011 16.9741C22.6336 16.439 22.4998 16.1714 22.3002 15.976C22.1237 15.8031 21.911 15.6716 21.6775 15.5911C21.4134 15.5 21.1142 15.5 20.516 15.5H17.3307C16.3973 15.5 15.9306 15.5 15.5741 15.6817C15.2605 15.8414 15.0055 16.0964 14.8457 16.41C14.6641 16.7665 14.6641 17.2332 14.6641 18.1667V18.8333M14.6641 18.8333H27.3307C28.7309 18.8333 29.4309 18.8333 29.9657 19.1058C30.4361 19.3455 30.8186 19.728 31.0582 20.1984C31.3307 20.7331 31.3307 21.4332 31.3307 22.8333V26.5C31.3307 27.9001 31.3307 28.6002 31.0582 29.135C30.8186 29.6054 30.4361 29.9878 29.9657 30.2275C29.4309 30.5 28.7309 30.5 27.3307 30.5H18.6641C17.2639 30.5 16.5639 30.5 16.0291 30.2275C15.5587 29.9878 15.1762 29.6054 14.9365 29.135C14.6641 28.6002 14.6641 27.9001 14.6641 26.5V18.8333Z",
    stroke: "#D92D20",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorToastIcon);
export default __webpack_public_path__ + "static/media/error-toast-icon.c29428f2c549ca284c90ee7ffc43209b.svg";
export { ForwardRef as ReactComponent };